module.exports = __webpack_public_path__ + "static/compass-a063c28c8441843a5b06af9e2341fbe4.jpg";